
  import { AccountModule, AccountStore } from '@/store/account';
  import { LicenseModule, LicenseStore } from '@/store/license';
  import { NavigationModule, NavigationStore } from '@/store/navigation';
  import { ActivationModule, ActivationStore } from '@/store/activations';
  import { Options, Vue } from 'vue-class-component';
  import { ref } from 'vue';
  import { FilterMatchMode, FilterService } from 'primevue/api';
  import FileService from '@/services/file.service';
  // import { ActivationRequestCommand, ActivationValidationCommand } from '@/apiclient/apiclient_generated';

  @Options({})
  export default class ActivationManagement extends Vue {
    private licenseStore: LicenseModule = LicenseStore;
    private accountStore: AccountModule = AccountStore;
    private navigationStore: NavigationModule = NavigationStore;
    private activationStore: ActivationModule = ActivationStore;

    showModal = false;
    loading = false;
    selectedAccount = null;
    selectedLicense = null;
    temp = null;
    temp2 = null;

    selectedActivation: any = ref();
    activationStateOptions = [
      'Activated',
      'MaximumActivationsReached',
      'LicenceKeyExpired',
      'LicenceOrAccountDeleted',
      'AlreadyActivated',
      'DomainMismatch'
    ];

    globalFilter = ['activationState', 'activationInfo.computerName', 'activationInfo.userDomainName', 'activationInfo.userName'];

    filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      activationState: { value: null, matchMode: FilterMatchMode.IN },
      'activationInfo.computerName': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'activationInfo.userDomainName': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'activationInfo.userName': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'activationInfo.productVersion': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'activationInfo.hostVersion': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'activationInfo.osVersion': { value: null, matchMode: FilterMatchMode.CONTAINS },
      endpoint: { value: null, matchMode: FilterMatchMode.CONTAINS },
      createTime: { value: null, matchMode: 'dateRange' },
      modifiedTime: { value: null, matchMode: 'dateRange' }
    });

    rows = 50;

    beforeMount() {
      FilterService.register('dateRange', (value: Date, filter: Date[]) => {
        if (!filter || filter.length === 0) return true;
        const [from, to] = filter;
        if (!from) return true;
        const date = new Date(value);
        date.setHours(0, 0, 0, 0);
        const fromDate = new Date(from);
        fromDate.setHours(0, 0, 0, 0);
        if (!to) return date >= fromDate;
        const toDate = new Date(to);
        toDate.setHours(23, 59, 59, 999);
        return date >= fromDate && date <= toDate;
      });
    }

    async mounted() {
      this.updateMenuActiveState();
      this.loading = true;

      this.activationStore.setLicenseActivations([]);
      await this.accountStore.getAllUsers();

      this.selectedAccount = +this.$route.query.account || null;

      if (this.selectedAccount) {
        await this.licenseStore.getAccountLicenses(this.selectedAccount);
      } else if (this.accountStore.isCustomer) {
        await this.licenseStore.getAccountLicenses(this.accountStore.userData.id);
      }

      this.selectedLicense = +this.$route.query.license || null;

      console.log('Selected license ' + this.selectedLicense);

      if (this.selectedLicense) {
        await this.activationStore.getLicenseActivations(this.selectedLicense);
      } else if (this.accountStore.isCustomer) {
        this.selectedLicense = this.licenseStore.selectedAccountLicenses[0].id;

        await this.activationStore.getLicenseActivations(this.selectedLicense);
      }

      this.selectFirstElementIfAny();

      this.loading = false;
    }

    updateMenuActiveState() {
      const params = {
        isAdmin: this.accountStore.isAdmin,
        route: this.$route.name
      };

      this.navigationStore.initMenuAction(params);
    }

    async processAccountFilterUpdate() {
      if (!this.selectedAccount) {
        this.selectedLicense = null;
      } else {
        this.loading = true;
        await this.licenseStore.getAccountLicenses(this.selectedAccount);
        this.loading = false;
      }
    }

    async processLicenseFilterUpdate() {
      if (!this.selectedLicense) {
        this.activationStore.setLicenseActivations([]);
      } else {
        await this.activationStore.getLicenseActivations(this.selectedLicense);
      }
    }

    get selectableAccounts() {
      return this.accountStore.allAccounts;
    }

    get selectedAccountDto() {
      return this.selectableAccounts.find((t) => t.id === this.selectedAccount);
    }

    get selectableLicenses() {
      return this.licenseStore.selectedAccountLicenses;
    }

    // async validate() {
    //   const command = {
    //     activationId: this.selectedActivation.autoId,
    //     licenseId: this.selectedActivation.licenseId,
    //     magic: '<Magic><ComputerName>LEGION</ComputerName><UserDomainName>LEGION</UserDomainName><UserName>USER</UserName>  <ProductVersion>1.0.0.0</ProductVersion><HostVersion>0</HostVersion><OSVersion>Microsoft Windows NT 6.2.9200.0</OSVersion></Magic>'
    //   } as ActivationValidationCommand;

    //   await this.activationStore.validateActivation(command);
    // }

    // async activate() {
    //   const key = this.licenseStore.selectedAccountLicenses.find((t) => t.id == this.selectedLicense).key;
    //   const command = {
    //     licenseKey: key,
    //     magic: '<Magic><ComputerName>LEGION</ComputerName><UserDomainName>LEGION</UserDomainName><UserName>USER</UserName>  <ProductVersion>1.0.0.0</ProductVersion><HostVersion>0</HostVersion><OSVersion>Microsoft Windows NT 6.2.9200.0</OSVersion></Magic>'
    //   } as ActivationRequestCommand;

    //   await this.activationStore.activateLicense(command);
    // }

    get items() {
      return this.activationStore.allActivations;
    }

    get totalRecords() {
      return this.activationStore.allActivations.length;
    }

    getLicenseItemLabel(license) {
      return `${license.product} - ${license.type}`;
    }

    getActivationLabel(activation) {
      return `${activation.product} - ${activation.hash}`;
    }

    async exportLicenseActivationsFromGrid(license) {
      await this._exportLicenseActivations([license.autoId]);
    }

    async exportLicenseActivations() {
      const ids = this.items.map((l) => l.autoId);

      await this._exportLicenseActivations(ids);
    }

    async exportClientLicenseActivations() {
      const ids = this.items.map((l) => l.autoId);

      await this._exportClientLicenseActivations(ids);
    }

    private async _exportLicenseActivations(licenseActivationIds) {
      const file = await this.activationStore.exportActivations(licenseActivationIds);

      if (file) {
        FileService.downloadFile(file.data, file.fileName);
      }
    }

    private async _exportClientLicenseActivations(licenseActivationIds) {
      const file = await this.activationStore.exportClientActivations(licenseActivationIds);

      if (file) {
        FileService.downloadFile(file.data, file.fileName);
      }
    }

    async deleteActivationFromGrid(data, $event) {
      this.selectedActivation = data;

      this.deleteLicenseActivation($event);
    }

    async deleteLicenseActivation(event) {
      const activation: any = this.selectedActivation;

      this.$confirm.require({
        target: event.currentTarget,
        message: 'Are you sure you want to delete selected license activation?',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          const isSuccess = await this.activationStore.deleteActivation(activation.autoId);
          if (isSuccess) {
            this.selectFirstElementIfAny();
          }
        },
        reject: () => {
          //callback to execute when user rejects the action
        }
      });
    }

    private selectFirstElementIfAny() {
      if (this.items.length) {
        this.selectedActivation = this.items[0];
      }
    }
  }
